
<template>
  <div>
   
    <ConsultationForm 
      @formSubmitted="handleFormSuccess" 
      :title="title" 
    />
    
    <SuccessModal 
      ref="successModal" 
      v-show="showSuccessModal" 
      :visible="showSuccessModal" 
      :message="'Форма успешно отправлена!'" 
      @close="closeSuccessModal" 
    />
  </div>
</template>

<script>
import SuccessModal from "@/components/Consultation/SuccessModal.vue";
import ConsultationForm from "@/components/Consultation/ConsultationForm.vue";

export default {
  components: { SuccessModal, ConsultationForm },
  props: {
    title: {
      type: String,
      required: false, 
    },
  },
  data() {
    return {
      showSuccessModal: false,
    };
  },
  methods: {
    handleFormSuccess() {
      this.showSuccessModal = true;
    },
    closeSuccessModal() {
      this.showSuccessModal = false;
    },
  },
};
</script>
